import { render, staticRenderFns } from "./ResetPasswordDefault.vue?vue&type=template&id=f1070b62&scoped=true&"
import script from "./ResetPasswordDefault.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDefault.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordDefault.vue?vue&type=style&index=0&id=f1070b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1070b62",
  null
  
)

export default component.exports